var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 490"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.651,
    cy: 175.289,
    r: 42.642
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.349,
    cy: 175.289,
    r: 42.642
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.723 364.15c4.396-3.26 108.787-78.91 214.584 0l18.303-24.554c-124.414-92.81-249.965-.912-251.221.015l18.334 24.539z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.086 490h351.829C459.001 490 490 459.001 490 420.914V69.086C490 30.991 459.001 0 420.914 0H69.086C30.999 0 0 30.991 0 69.086v351.829C0 459.001 30.999 490 69.086 490zM30.625 69.086c0-21.204 17.256-38.461 38.461-38.461h351.829c21.204 0 38.461 17.257 38.461 38.461v351.829c0 21.204-17.257 38.461-38.461 38.461H69.086c-21.204 0-38.461-17.257-38.461-38.461V69.086z"
  })));
}
export default SvgSadFace;